import React from "react";
import "./nbfc-partner.css";

const nbfcList = [
  { type: "logo", name: "Vanshika Micro Credit" },
  { type: "text", name: "ACG Leasing Limited" },
  { type: "text", name: "MARATHON FINLEASE PVT LTD" },
  { type: "text", name: "SINGH FINLEASE PVT LTD" },  
];

const NBFCPartner = () => {
  return (
    <section className="nbfc-section py-4 py-md-5">
      <div className="nbfc-background"></div>

      <div className="content-wrapper container">
        <h2 className="h4 performance-title text-dark mb-3 text-center">
          <span className="nbfc-title">Our NBFC Partners</span>
        </h2>

        <p className="section-subtitle text-center mb-4 mb-md-5">
          A team of trusted experts who support our financial growth and scalability.
          They help us turn vision into viable ventures with stability and speed.
        </p>

        <div className="row justify-content-center mt-4">
  {nbfcList.map((nbfc, index) => (
    <div key={index} className="col-md-3 col-6 text-center mb-4">
      {nbfc.type === "logo" && nbfc.img ? (
        <img
          src={nbfc.img}
          alt={nbfc.name}
          className="partner-logo"
          onError={(e) => { e.target.onerror = null; e.target.style.display = "none"; }}
        />
      ) : (
        <p className="partner-name-glow">{nbfc.name}</p>
      )}
    </div>
  ))}
</div>

      </div>
    </section>
  );
};

export default NBFCPartner;
